import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
const SvgComponent = (props: SvgProps) => (
  <Svg width={20} height={20} fill="none" {...props}>
    <Path
      fill="#000"
      stroke="#F3EAE1"
      strokeWidth={0.25}
      d="m15.657 14.764-.029-.084h-3.557l-.029.084-.702 2.034h-1.197l3.06-8.057h1.259l3.056 8.057h-1.154l-.707-2.034Zm-3.179-1.222-.059.167h2.822l-.06-.167-1.21-3.42-.03-.083h-.225l-.03.083-1.208 3.42ZM7.88 11.297 4.506 14.67l-.816-.817 3.414-3.415.084-.084-.08-.088c-.429-.475-.804-.968-1.127-1.479l-.106.067.106-.067c-.29-.458-.546-.935-.768-1.431h1.168c.204.387.417.738.64 1.053.234.332.518.686.85 1.062l.092.103.093-.101c.525-.567.96-1.141 1.303-1.723a9.526 9.526 0 0 0 .843-1.864l.054-.165H2.554V4.587h4.847V3.202h1.134v1.385h4.846V5.72h-2.004l-.026.09a12.962 12.962 0 0 1-.973 2.346l.103.055-.103-.055c-.406.764-.91 1.48-1.513 2.15l-.078.088.082.084 1.598 1.626-.433 1.169-1.978-1.977-.088-.089-.088.088Z"
    />
  </Svg>
);
export default SvgComponent;
